import React from 'react';
import { Filter, Download, Inbox } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Submissions() {
  const {
    submissions
  } = useWorkspace();
  return <div className="space-y-6" data-id="element-1836">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-1837">
        <div className="min-w-0" data-id="element-1838">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-1839">
            Form Submissions
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1840">
            Raw log of all form posts received.
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0" data-id="element-1841">
          <button className="inline-flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 whitespace-nowrap" data-id="element-1842">
            <Filter className="h-4 w-4 flex-shrink-0" data-id="element-1843" />
            <span data-id="element-1844">Filter</span>
          </button>
          <button className="inline-flex items-center gap-2 px-3 py-2 bg-white border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 whitespace-nowrap" data-id="element-1845">
            <Download className="h-4 w-4 flex-shrink-0" data-id="element-1846" />
            <span data-id="element-1847">Export</span>
          </button>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1848">
        {submissions.length === 0 ? <div className="p-12 text-center" data-id="element-1849">
            <Inbox className="mx-auto h-12 w-12 text-gray-400" data-id="element-1850" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-1851">
              No submissions found
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-1852">
              Submissions for this workspace will appear here.
            </p>
          </div> : <div className="overflow-x-auto" data-id="element-1853">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-1854">
              <thead className="bg-gray-50" data-id="element-1855">
                <tr data-id="element-1856">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1857">
                    Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1858">
                    Email
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1859">
                    Source Form
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1860">
                    IP Address
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1861">
                    Status
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-1862">
                    Payload
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-1863">
                {submissions.map(sub => <tr key={sub.id} className="hover:bg-gray-50" data-id="element-1864">
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1865">
                      {sub.date}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1866">
                      <span className="text-sm font-medium text-gray-900 truncate block max-w-[200px]" data-id="element-1867">
                        {sub.email}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1868">
                      <span className="text-sm text-gray-500 truncate block max-w-[150px]" data-id="element-1869">
                        {sub.form}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono" data-id="element-1870">
                      {sub.ip}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-1871">
                      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${sub.status === 'accepted' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-1872">
                        {sub.status}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm text-blue-600 hover:text-blue-900 cursor-pointer" data-id="element-1873">
                      View JSON
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </div>;
}